// extracted by mini-css-extract-plugin
export default {"navbarSection":"navbar_navbarSection__wKpxx"};